import script from "./PopularFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularFeed.vue?vue&type=script&setup=true&lang=js"

import "./PopularFeed.vue?vue&type=style&index=0&id=d4e8c0b8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e8c0b8"]])

export default __exports__